import { serverOnly$ } from 'vite-env-only/macros'

function getEnv(key: string) {
  if (!process.env[key]) {
    throw new Error(`${key} env variable is not set`)
  }
  return process.env[key]
}

export const env = serverOnly$({
  VAULTS_API_KEY: getEnv('VAULTS_API_KEY'),
  VAULTS_API_URL: getEnv('VAULTS_API_URL'),
  INFURA_API_KEY: getEnv('INFURA_API_KEY'),
  ROUTEME_API_KEY: getEnv('ROUTEME_API_KEY'),
})!
